
import { createSlice } from '@reduxjs/toolkit';


const initialState = {
     loading: false,
        main_loading: true,
        data: {},
        sites:[],
        main_data: {},
        error: false,
    lastFetched: null,
};

// Try to load from localStorage
const saved = localStorage.getItem('cachedSites');
if (saved) {
  try {
    const parsed = JSON.parse(saved);
    initialState.sites = Array.isArray(parsed?.sites) ? parsed.sites : [];
    initialState.lastFetched = parsed?.lastFetched || null;
  } catch (err) {
    console.error('Error parsing localStorage cachedSites:', err);
  }
}


export const siteCodeSlice = createSlice({
    name:'siteCode',
    initialState:initialState,
    reducers:{
        SITE_CODE_FETCH_START:(state)=>{
            state.loading=true
        },
        SITE_CODE_FETCH_SUCCESS:(state,action)=>{
                 state.loading=false
            state.sites=action.payload;
             state.lastFetched = Date.now();

            // ✅ Save to localStorage
            localStorage.setItem('cachedSites', JSON.stringify({
                sites: action.payload,
                lastFetched: Date.now()
            }));
        },
        SITE_CODE_FETCH_MORE_SUCCESS:(state,action)=>{
             state.loading=false
            state.sites=[...state.sites,...action.payload]

            // ✅ Save to localStorage
            localStorage.setItem('cachedSites', JSON.stringify({
                sites: state.sites,
                lastFetched: Date.now()
            }));
        },
        SITE_CODE_FETCH_ERROR:(state)=>{
            state.error=true
        }
    }
});

export const { SITE_CODE_FETCH_START,SITE_CODE_FETCH_ERROR,SITE_CODE_FETCH_SUCCESS, SITE_CODE_FETCH_MORE_SUCCESS }=siteCodeSlice.actions;
export default siteCodeSlice.reducer;